export default {
  label: {
    tooltip: {
      info: 'Filtro del componente',
    },
    icon: {
      key: 'F',
    },
  },
};
